import { LanghoutBetonPortal } from './LanghoutBetonPortal.js';

customElements.define('langhout-beton-portal', LanghoutBetonPortal);
